import { render, staticRenderFns } from "./OrderAjax.vue?vue&type=template&id=75b86ba1&scoped=true&"
import script from "./OrderAjax.vue?vue&type=script&lang=js&"
export * from "./OrderAjax.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75b86ba1",
  null
  
)

export default component.exports